import {Component, Inject} from '@angular/core';
import {NavParams, ViewController} from 'ionic-angular';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {EnvVariables} from '../../../../environment-variables/environment-variables.token';
import {PrismConfigOptions} from '../../../../environment-variables/environment-variables.interface';

/**
 * Preview component
 */
@Component({
  selector: 'advtech-preview',
  templateUrl: './preview-modal.component.html',
})
export class PreviewModalComponent {
  /**
   * display model used for preview
   * @type {string}
   */
  display: string = 'mobile';

  /**
   * used in iframe srca
   * @type {SafeResourceUrl}
   */
  previewUrl: SafeResourceUrl;

  /**
   * The content type name
   * @private
   * @type {string}
   */
  private contentTypeName: string;

  /**
   * version id of content
   * @private
   * @type {string}
   */
  private id: string;

  /**
   * @constructor
   * @param {ViewController} viewCtrl View Controller Instance
   * @param {NavParams} navParams NavParams Instance
   * @param {Object} envVariables Configuration for the current environment
   * @param {DomSanitizer} sanitizer DomSanitizer instance
   */
  constructor(private viewCtrl: ViewController, private navParams: NavParams, @Inject(EnvVariables) public envVariables: PrismConfigOptions, private sanitizer: DomSanitizer) {
    this.contentTypeName = this.navParams.get('contentTypeName');
    this.id = this.navParams.get('id');
    this.previewUrl = this.constructPreviewUrl();
  }

  /**
   * triggered when display changes
   * @returns {void}
   */
  hDisplayChange(): void {
    this.previewUrl = this.constructPreviewUrl();
  }

  /**
   * Dismisses the modal
   *
   * @returns {Promise<any>}
   */
  dismiss(): Promise<any> {
    return this.viewCtrl.dismiss({status: 'close'});
  }

  /**
   * Generates the preview url
   *
   * @returns {SafeResourceUrl}
   */
  constructPreviewUrl(): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.envVariables.hubApi + '/mobile/content/preview/' + this.contentTypeName + '/' + this.id + '/' + this.display);
  }
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/preview-modal/preview-modal.component.ts